import React, { FC } from 'react';
import { TextLink as UIKitTextLink } from '@landlord-tech/ui-kit-opp/dist/components/TextLink';
import { Link } from 'react-router-dom';
import { ETextLinkColors, TTextLinkProps } from './TextLink.types';

const TextLink: FC<TTextLinkProps> = ({
  children,
  fontWeight,
  fontLevel,
  linkText,
  to = '',
  state = {},
  type,
  onClick,
  ...rest
}) => {
  return (
    <UIKitTextLink
      fontWeight={fontWeight}
      fontLevel={fontLevel}
      type={type}
      linkComponent={
        <>
          {' '}
          <Link onClick={onClick} to={to} state={state} {...rest}>
            {linkText}
          </Link>
        </>
      }
    >
      {children}
    </UIKitTextLink>
  );
};

export { ETextLinkColors };

export default TextLink;
